import {
  initialState,
  Actions,
  State,
  GET_ENTITY,
  GET_ENTITY_SUCCESS,
  GET_ENTITY_ERROR,
  RESET_GET_ENTITY,
} from '../../types/enargas/get-entity'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ENTITY:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_ENTITY_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_ENTITY_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_GET_ENTITY:
      return initialState
    default:
      return state
  }
}

export default reducers
